import React from 'react';
import { PropTypes } from 'prop-types';
import HrbTranslate from "../language/HrbTranslate";
import './ActionLink.scss'

const ActionLink = (props) => (
    <div className="hrb-link" onClick={props.onClick}>
      <span className="hrb-action-link">
        <HrbTranslate text={props.text} params={props.params}/>
      </span>
    </div>
);

ActionLink.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func
};

export default ActionLink;